
    import {computed, ComputedRef, defineComponent, reactive, watch} from 'vue'
    import {useStore} from "@/store";
    import {useRoute} from "vue-router";
    import componentTitle from './componentTitle.vue';
    import defectList from './defectList.vue';

    interface TitleData {
        text: string;
        icon: string;
        clickFun: string;
    }

    interface State {
        titleText: string;
        titleData: TitleData;
        defectList: object[];
        listName: string;
        listDefectNumber: number;
        importantNumber: number;
        listSumNumber: number;
        reportLevel: number;
    }

    export default defineComponent({
        name: "InteriorCheck",
        setup() {
            let state: State = reactive({
                titleText: '内饰检测',
                titleData: {
                    text: '标准说明',
                    icon: 'shuoming.png',
                    clickFun: 'showRemind',
                    modelCnt: [
                        '【内饰检测标准】如检测项中出现划痕、脏污、破损、更换、拆卸未换、缝隙不均、改装、磨损、老化、缺失、烟头烫伤、故障、变形、修复痕迹等缺陷状况，根据《268V检测认证标准》综合判断为内饰缺陷。',
                        'prop_up_height',
                        '【受限不可检】检测过程中，受环境、车主授权等不可抗原因导致无法检测，268V不对受限不可检的检测项产生的任何疑问负责。'
                    ]
                },
                defectList: [],
                listName: '内饰检测',
                listDefectNumber: 0,
                importantNumber: 0,
                listSumNumber: 0,
                reportLevel: 0,
            })
            const {query} = useRoute();
            state.reportLevel = Number(`${query.reportLevel}`) || 0;
            let store = useStore()
            let dataInfo: ComputedRef<{}> = computed<{}>(() => store.state.dataInfo)
            watch(dataInfo, (data: any) => {
                const {interior} = data;
                if (interior) {
                    const {importantItemCount, defectItemCount, itemCount, itemList, itemTitle} = interior
                    state.defectList = itemList;
                    state.listName = itemTitle;
                    state.listDefectNumber = defectItemCount;
                    state.importantNumber = importantItemCount;
                    state.listSumNumber = itemCount;
                }
            })
            return {
                state
            }
        },
        components: {
            componentTitle, defectList
        }
    })
